<template>
  <div id="discovery-root">
    <div id="nav">
      <button class="discovery-button" @click="switchView('discovery')" @keyup="switchView('discovery')">{{ $t("labels.discovery") }}</button>
      <button class="discovery-button" @click="switchView('debug')" @keyup="switchView('debug')">Debug</button>
      <button class="discovery-button" @click="switchView('rec')" @keyup="switchView('rec')">Recommendation</button>
    </div>
    <discovery-view v-if="activeView === 'discovery'" />
    <debug :cn="1281142" v-if="activeView === 'debug'" />
    <recommendation v-if="activeView === 'rec'" :test_cn="1281142" :test_blurb="testBlurb" />
  </div>
</template>

<script>
import DiscoveryView from '@/components/views/Discovery.vue';
import Recommendation from '@/components/entries/Recommendation.vue';
import Debug from '@/components/views/Debug.vue';

export default {
  name: 'TestView',
  data() {
    return {
      activeView: this.$root.params.view,
      // eslint-disable-next-line max-len
      testBlurb: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>',
    };
  },
  components: {
    DiscoveryView,
    Recommendation,
    Debug,
  },
  methods: {
    switchView(v) { this.activeView = v; },
  },
  created() {
  },
  mounted() {
  },
};

</script>

<style lang="less">
@import '~@/css/global';
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
  }
}
</style>
